import axios from 'axios'
import router from '../router/index'
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export function deepClone(data) {
  if (!data || !(data instanceof Object) || (typeof data === 'function')) {
    return data || undefined
  }
  var constructor = data.constructor
  var result = new constructor()
  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      result[key] = deepClone(data[key])
    }
  }
  return result
}

export function checkEmail(str) {
  var result = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
  if (result.test(str)) {
    return true
  } else {
    return false
  }
}

export function checkUrl(url) {
  return /^(https:\/\/|http:\/\/|www\.)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/]+)+$/.test(url.split('?')[0])
}

// 校验国外手机号，保证不超17位
export function checkMobileOversea(mobile) {
  if (!mobile) {
    return;
  }
  if (mobile.length < 7) {
    return false
  }
  if (mobile.length > 17) {
    return false
  }
  if (!(new RegExp(/^\d{1,17}$/).test(mobile))) {
    return false
  }
  return true
}

// 获取服务器返回的图片文件
export function getBase64(imgUrl, width, height) {
  var image = new Image()
  image.src = imgUrl
  var canvas = document.createElement('canvas')
  canvas.width = width || image.width
  canvas.height = height || image.height
  var ctx = canvas.getContext('2d')
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
  var dataURL = canvas.toDataURL()
  return dataURL
}

//定义一个加法函数
export function add() {
  var args = arguments,
    lens = args.length,
    d = 0,
    sum = 0;
  for (var key in args) {
    var str = "" + args[key];
    if (str.indexOf(".") != -1) {
      var temp = str.split(".")[1].length;
      d = d < temp ? temp : d;
    }
  }
  var m = Math.pow(10, d);
  for (var key in args) {
    sum += args[key] * m;
  }
  return sum / m;
}


export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          this.$message.error(response.statusText)
        }
      }, err => {
        reject(err)
      })
  })
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          this.$message.error(response.statusText)
        }
      }, err => {
        reject(err)
      })
  })
}

export function get(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, data)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          this.$message.error(response.statusText)
        }
      }, err => {
        reject(err)
      })
  })
}

export function del(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          this.$message.error(response.statusText)
        }
      }, err => {
        reject(err)
      })
  })
}

export function form(url, formData = {}) {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return new Promise((resolve, reject) => {
    axios.post(url, formData, config)
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          this.$message.error(response.statusText)
        }
      }, err => {
        reject(err)
      })
  })
}

export function compareDate(date1, date2, fg) {
  var oDate1 = new Date(date1)
  var oDate2 = new Date(date2)
  if (fg === "equal" && oDate1.getTime() == oDate2.getTime()) {
    return true
  } else if (oDate1.getTime() >= oDate2.getTime()) {
    return false
  } else {
    return true
  }
}

//监听文本域输入，高度自动变化
export function makeExpandingArea(el) {
  var timer = null;
  //由于ie8有溢出堆栈问题，故调整了这里
  var setStyle = function (el, auto) {
    if (auto) el.style.height = 'auto';
    el.style.height = el.scrollHeight + 'px';
  }
  var delayedResize = function (el) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    timer = setTimeout(function () {
      setStyle(el)
    }, 200);
  }
  if (el.addEventListener) {
    el.addEventListener('input', function () {
      setStyle(el, 1);
    }, false);
    setStyle(el)
  } else if (el.attachEvent) {
    el.attachEvent('onpropertychange', function () {
      setStyle(el)
    })
    setStyle(el)
  }
  if (window.VBArray && window.addEventListener) { //IE9
    el.attachEvent("onkeydown", function () {
      var key = window.event.keyCode;
      if (key == 8 || key == 46) delayedResize(el);

    });
    el.attachEvent("oncut", function () {
      delayedResize(el);
    }); //处理粘贴
  }
}

//监听文本换行
export function exeTextLine(obj, cla) {
  if (obj == "") {
    var textareaList = document.getElementsByClassName(cla);

    for (var i = 0; i < textareaList.length; i++) {
      makeExpandingArea(textareaList[i]);
    }
  } else {
    makeExpandingArea(obj);
  }

}

export function formatDate(date) {
  let year = date.getFullYear()
  let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString() // '04'
  // 获取天，判断是否小于10，如果是在字符串前面拼接'0'
  let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate().toString()
  return `${year}-${month}-${day}`;
}
// new Date(2020, 0, 8)
export function formatDate2Day(date) {
  let year = date.getFullYear()
  let month = date.getMonth().toString()
  let day = date.getDate().toString()
  return new Date(year, month, day);
}

// 获取上个月的天数
function getMonthDay(year, month) {
  let days = new Date(year, month, 0).getDate()
  return days
}
// 获取当前月份的天数
function getDays(year, month) {
  let days = [31, 28, 31, 30, 31, 30, 31, 30, 30, 31, 30, 31]
  if ((year % 4 === 0) && (year % 100 !== 0 || year % 400 === 0)) {
    days[1] = 29
  } return days[month]
}

export function getStartDateOf1Month() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth() + 1;//0-11表示1-12月
  var day = now.getDate();
  var dateObj = {};
  dateObj.now = year + '-' + month + '-' + day;
  switch (month) {
    case 1: // 31
      if (day < 31) { //如果是1月份，则取上一年的12月份
        dateObj.last = year - 1 + '-12-' + (day + 1);
      } else {
        dateObj.last = year + '-1-' + 1;
      }
      break;
    case 2: // 28
      if (day === getDays(year, now.getMonth())) {
        dateObj.last = year + '-2-' + 1;
      } else {
        dateObj.last = year + '-1-' + (day + 1);
      }
      break;
    case 3: // 31
      if (day < 28) {
        dateObj.last = year + '-2-' + (day + 1);
      } else if (day === 31) {
        dateObj.last = year + '-3-' + 1;
      } else {
        let lastMonthDay = (getMonthDay(year, month) - (31 - day) + 1) === 0 ? 1 : 31;
        if (lastMonthDay === 1) {
          dateObj.last = year + '-2-' + 1;
        } else {
          dateObj.last = year + '-1-' + 31;
        }
      }
      break;
    case 4:
      if (day < 30) {
        dateObj.last = year + '-3-' + (day + 1);
      } else {
        dateObj.last = year + '-4-' + 1;
      }
      break;
    case 5:
      if (day < 30) {
        dateObj.last = year + '-4-' + (day + 1);
      } else if(day === 31){
        dateObj.last = year + '-5-' + 1;
      } else {
        dateObj.last = year + '-4-' + 30;
      }
      break;
    case 6:
      if (day < 30) {
        dateObj.last = year + '-5-' + (day + 1);
      } else {
        dateObj.last = year + '-6-' + 1;
      }
      break;
    case 7:
      if (day < 30) {
        dateObj.last = year + '-6-' + (day + 1);
      } else if(day === 31){
        dateObj.last = year + '-7-' + 1;
      } else {
        dateObj.last = year + '-6-' + 30;
      }
      break;
    case 8:
      if (day < 31) {
        dateObj.last = year + '-7-' + (day + 1);
      } else {
        dateObj.last = year + '-8-' + 1;
      }
      break;
    case 9:
      if (day < 30) {
        dateObj.last = year + '-8-' + (day + 1);
      } else {
        dateObj.last = year + '-9-' + 1;
      }
      break;
    case 10:
      if (day < 30) {
        dateObj.last = year + '-9-' + (day + 1);
      } else if(day === 31){
        dateObj.last = year + '-10-' + 1;
      } else {
        dateObj.last = year + '-9-' + 30;
      }
      break;
    case 11:
      if (day < 30) {
        dateObj.last = year + '-10-' + (day + 1);
      } else {
        dateObj.last = year + '-11-' + 1;
      }
      break;
    case 12:
      if (day < 30) {
        dateObj.last = year + '-11-' + (day + 1);
      } else if(day === 31){
        dateObj.last = year + '-11-' + 1;
      } else {
        dateObj.last = year + '-10-' + 30;
      }
      break;
  }
  let lastMonthDay = dateObj.last.split('-'); //2020-6-17
  return new Date(lastMonthDay[0], parseInt(lastMonthDay[1])-1, lastMonthDay[2]);
}

export function getDate(dateTime) {
  var YYYY = dateTime.getFullYear();
  var MM = dateTime.getMonth() + 1;
  if (MM < 10) MM = "0" + MM;
  var DD = dateTime.getDate();
  if (DD < 10) DD = "0" + DD;
  var HH = dateTime.getHours();
  if (HH < 10) HH = "0" + HH;
  var mm = dateTime.getMinutes();
  if (mm < 10) mm = "0" + mm;
  var ss = dateTime.getSeconds();
  return YYYY + "-" + MM + "-" + DD + " " + HH + ":" + mm + ":" + ss;
}

var subscribers = [];
var isRefreshing = true;
function goLogin() {
  router.replace({ path: '/' })
}
function onAccessTokenFetched() {
  subscribers.forEach((callback) => {
    callback();
  })
  subscribers = [];
}
function addSubscriber(callback) {
  subscribers.push(callback)
}
function refreshTokenRequst() {
  var refreshToken = localStorage.getItem('refresh_token');
  axios({
    method: 'post',
    url: `api/dashboard/refresh?refresh_token=${refreshToken}`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }).then((response) => {
    var respData = response.data
    if (respData.code === "10000") {
      const tokenVo = {
        Authorization: respData.data.access_token,
        refreshToken: respData.data.refresh_token
      }
      localStorage.setItem('Authorization', tokenVo.Authorization)
      localStorage.setItem('sessionTime', respData.data.expires_in)
      localStorage.setItem('startTime', new Date().getTime())
      localStorage.setItem('refresh_token', tokenVo.refreshToken);
      onAccessTokenFetched();
      isRefreshing = true;
    } else {
      if (respData.code === "20002") {
        goLogin();
      }
    }
  });
}

function checkStatus(response) {
  return response;
}
function errCkStatus(response) {
  if (response && response.status === 401) {
    if (isRefreshing) {
      refreshTokenRequst()
    }
    isRefreshing = false;
    const retryOriginalRequest = new Promise(
      (resolve) => {
        addSubscriber(() => {
          resolve(request(options))
        })
      });
    return retryOriginalRequest;
  } else {
    return response;
  }
}
export function request(options) {
  return axios(options)
    .then(checkStatus)
    .catch(error => {
      errCkStatus(error.response, options)
    });
}

// Shoplazza / external plugin only — must not affect dashboard login flow
const SHOPLAZZA_LOGIN_REDIRECT_KEY = 'shoplazza_login_redirect'

function decodePath(path) {
  if (typeof path !== 'string' || !path) return ''
  try {
    return decodeURIComponent(path)
  } catch (e) {
    return path
  }
}

/** Shoplazza bind URL must be /plugin/auth-bind and include non-empty state */
function isShoplazzaRedirectPath(path) {
  const decoded = decodePath(path)
  if (!decoded || decoded.startsWith('//') || !decoded.startsWith('/plugin/auth-bind')) {
    return false
  }
  const qIndex = decoded.indexOf('?')
  if (qIndex < 0) return false
  const params = new URLSearchParams(decoded.slice(qIndex + 1))
  const state = params.get('state')
  return !!(state && String(state).trim())
}

export function saveShoplazzaLoginRedirect(fullPath) {
  if (!isShoplazzaRedirectPath(fullPath)) return
  try {
    sessionStorage.setItem(SHOPLAZZA_LOGIN_REDIRECT_KEY, fullPath)
  } catch (e) {}
}

export function clearShoplazzaLoginRedirect() {
  try {
    sessionStorage.removeItem(SHOPLAZZA_LOGIN_REDIRECT_KEY)
  } catch (e) {}
}

function resolveShoplazzaRedirect(routeQuery) {
  const fromQuery = routeQuery && routeQuery.redirect
  if (isShoplazzaRedirectPath(fromQuery)) {
    return decodePath(fromQuery)
  }
  let stored = ''
  try {
    stored = sessionStorage.getItem(SHOPLAZZA_LOGIN_REDIRECT_KEY) || ''
  } catch (e) {}
  return isShoplazzaRedirectPath(stored) ? stored : null
}

/**
 * Login page entry: keep cache only when URL carries a valid Shoplazza redirect
 * ( /plugin/auth-bind?...&state=... ). Otherwise clear so normal login is unaffected.
 */
export function syncShoplazzaLoginRedirectOnLoginPage(routeQuery) {
  if (isShoplazzaRedirectPath(routeQuery && routeQuery.redirect)) {
    saveShoplazzaLoginRedirect(decodePath(routeQuery.redirect))
    return
  }
  clearShoplazzaLoginRedirect()
}

/** Only returns valid Shoplazza bind URL with state; otherwise null */
export function consumeShoplazzaLoginRedirect(routeQuery) {
  const redirect = resolveShoplazzaRedirect(routeQuery)
  clearShoplazzaLoginRedirect()
  return redirect
}

export function queryCountryByCode(code) {
  var regions = {
    "BRA": "Brazil",
    "MEX": "Mexico",
    "PHL": "Philippines",
    "RUS": "Russian Federation",
    "IND": "India"
  };
  return regions[code];
}

// 格式化CPF或CNPJ
export function formatUserCredentials(type, number) {
  let signInfo = '';
  switch(type.toUpperCase()) {
    case 'CPF': // 466.622.636-66
      signInfo = number.substring(0, 3) + '.' + number.substring(3, 6) + '.' + number.substring(6, 9) + '-' + number.substring(9);
      break;
    case 'CNPJ': // 23.010.551/0001-31
    signInfo = number.substring(0, 2) + '.' + number.substring(2, 5) + '.' + number.substring(5, 8) + '/' + number.substring(8, 12) + '-' + number.substring(12);
      break;
  }
  return signInfo;
}
// 比较简洁的uuid生成方法
export function guid(){
  function S4(){
      return ( (1 + Math.random()) * 0x10000 | 0 ).toString(16).substring(1);
  }
  return S4()+S4()+'-'+S4()+'-'+S4()+'-'+S4()+'-'+S4()+S4()+S4();
}

export function downloadImage(imgSrc, name) {
  var canvas = document.createElement('canvas');
  var img = document.createElement('img');
  img.onload = function(e) {
    canvas.width = img.width;
    canvas.height = img.height;
    var context = canvas.getContext('2d');
    context.drawImage(img, 0, 0, img.width, img.height);
    canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);
    canvas.toBlob((blob)=>{
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name || "voucher_" + Math.floor((Math.random()*10000000)+1);;
      link.click();
    }, "image/jpeg");
  }
  img.setAttribute("crossOrigin",'Anonymous');
  img.src = imgSrc;
}

/*获取到Url里面的参数*/
export function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
/**
 * [isDefine 判断值是否定义]
 * @param  {[string]}  value
 * @return {Boolean}
 */
export function isDefine(value) {
	if (value == null || value == "" || value == "undefined" || value == undefined || value == "null" || value == "(null)" || value == 'NULL' || typeof(value) == 'undefined') {
		return false;
	} else {
		value = value + "";
		value = value.replace(/\s/g, ""); //全局匹配空白字符
		if (value == "") {
			return false;
		}
		return true;
	}
}

const canvas2PDF = (canvas, filename, resolve) => {
  let contentWidth = canvas.width;
  let contentHeight = canvas.height;

  //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
  let imgWidth = 595.28;
  let imgHeight = (592.28 / contentWidth) * contentHeight;

  let pageHeight = (contentWidth / 592.28) * 841.89;
  let totalHeight = contentHeight;

  // 第一个参数： l：横向  p：纵向
  // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
  let pdf = new jsPDF("p", "pt");
  let position = 0;

  if (totalHeight < pageHeight) {
    pdf.addImage(
      canvas.toDataURL("image/jpeg", 1.0),
      "JPEG",
      0,
      0,
      imgWidth,
      imgHeight
    );
  } else {
    while (totalHeight > 0) {
      pdf.addImage(
        canvas.toDataURL("image/jpeg", 1.0),
        "JPEG",
        0,
        position,
        imgWidth,
        imgHeight
      );

      totalHeight -= pageHeight;

      position -= 841.89;

      //避免添加空白页

      if (totalHeight > 0) {
        pdf.addPage();
      }
    }
  }

  pdf.save(filename + ".pdf");
  resolve("success");
};

export const downloadPDF = (page, filename) => {
  return new Promise((resolve) => {
    html2canvas(page).then(function(canvas) {
      canvas2PDF(canvas, filename, resolve);
    });
  });
};
export function setDataItem(key, value, storageName) {
  const storage = JSON.parse(window.localStorage.getItem(storageName) || '{}')
  storage[key] = value
  window.localStorage.setItem(storageName, JSON.stringify(storage))
}
export function getDataItem(key, storageName) {
  const storage = JSON.parse(window.localStorage.getItem(storageName) || '{}')
  return storage[key]
}
export function clearItem(key, storageName) {
  const storage = JSON.parse(window.localStorage.getItem(storageName) || '{}')
  delete storage[key]
  window.localStorage.setItem(storageName, JSON.stringify(storage))
}

